import ApiResourceManager from '../ApiResourceManager';

// Maxwell, the tech-issue triage agent (separate service, VITE_MAXWELL_API_BASE_URL).
// Use with useApiClient({ baseUrl: import.meta.env.VITE_MAXWELL_API_BASE_URL }).
export default class MaxwellTicketsManager extends ApiResourceManager {
  // Product areas, impacts and scopes the form offers; owned by Maxwell's repo index.
  getChoices = () =>
    this.request({
      method: 'GET',
      url: '/ticket-areas',
    });

  // The Slack workspace's people, for the form's Reporter field.
  getSlackMembers = () =>
    this.request({
      method: 'GET',
      url: '/slack-members',
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/tickets',
      data,
    });

  // Every open ticket and those closed in the last 60 days, with their status.
  list = () =>
    this.request({
      method: 'GET',
      url: '/tickets',
    });

  // One ticket: description, plain-language timeline and its Slack conversation.
  show = (id) =>
    this.request({
      method: 'GET',
      url: `/tickets/${id}`,
    });
}
